// extracted by mini-css-extract-plugin
module.exports = {"errorList":"ValidateDocumentErrorModal_errorList_3uhd1","spinAround":"ValidateDocumentErrorModal_spinAround_284dD"};